/**
 * Created by Marcus Zhao on 5/14/2020.
 * ------ maintenance history ------
 *
 */

export class RelationshipDialogOpenOptions {
    relationshipId?: string;
    relationshiTyeName?: string;
    controlId?: string;
}
